import React, { useRef, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import SignaturePad from "react-signature-canvas";
import signText from 'src/Assets/Images/sing-text.png';
import useTailwindBrand from 'src/Theme/useTailwindBrand';
import { useProcurationContext } from 'src/Contexts/ProcurationContext';
import { useProcuration } from 'src/Hooks/useProcuration';
import DialogLayout from 'src/Components/DialogLayout';
import LayoutProcuration from 'src/Components/Procuration/LayoutProcuration';

const ThirdProcuration = () => {
    const { classes, brandConfig, common } = useTailwindBrand();
    const context = useProcurationContext();
    const { prevStep, setSignature, setSignatureText, generalProcuration, dispatch, setProofIsAe, pdfDoc, teachr, triggerPdfUpdate, typeOfProcuration, loading } = context;
    useProcuration({ pdfDoc, teachr, triggerPdfUpdate })
    const [dataURL, setDataURL] = useState<string | null>(null);
    const [show, setShow] = useState(true);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState<boolean | null>(null);
    const [isSign, setIsSign] = useState(false);
    const [isApply, setApply] = useState(false);
    const [text, setText] = useState('');
    const padRef = useRef<SignaturePad>(null);

    const clear = () => {
        if (padRef.current) {
            padRef.current.clear();
        }
        setDataURL(null);
        setShow(true);
    };

    const trim = () => {
        const url = padRef.current?.getTrimmedCanvas().toDataURL("image/png");
        if (url) {
            setDataURL(url);
        }
    };

    const validateSign = () => {
        trim();
        if (dataURL && setSignature) {
            setSignature(dataURL);
            setOpen(false);
            setIsSign(true);
        }
    };

    const clearText = () => {
        setText('');
        setError(null);
    };

    const validateText = () => {
        if (text.toLowerCase().replace(/["'\s]/g, '') === 'bonpourpouvoir') {
            setError(false);
            setApply(true);
            if (setSignatureText) {
                setSignatureText(signText);
            }
        } else {
            setError(true);
            setTimeout(clearText, 2000);
        }
    };
    
    const handleNext = () => {
        if (!isSign) {
            if (dataURL) {
                setOpen(true);
            }
        } else if (!isApply) {
            if (text !== '') {
                validateText();
                triggerPdfUpdate()
            }
        } else {
            if (typeOfProcuration === 30) {
                const payload = {
                    step: 9,
                    secondProc: generalProcuration?.secondProc || {},
                    thirdProc: generalProcuration?.thirdProc || {},
                    fourthProc: generalProcuration?.fourthProc || {},
                    fifthProc: generalProcuration?.fifthProc || {},
                    sixthProc: generalProcuration?.sixthProc || {},
                    legalRepProc: generalProcuration?.legalRepProc || [],
                    seventhProc: generalProcuration?.seventhProc || {},
                    eightProc: isSign
                }
                dispatch({ type: 'SET_AE_INFO', payload })
            } else {
                const payload = {
                    step: 5,
                    first: generalProcuration?.first || {},
                    second: generalProcuration?.second || {},
                    third: generalProcuration?.third || {},
                    fourth: isSign
                }
                dispatch({ type: 'SET_SAP_INFO', payload })
            }
            setProofIsAe()
        }
    };

    return (
        <>
            <LayoutProcuration
                title="Signature"
                icon={<EditIcon className={`w-6 h-6 ${classes.primaryText}`} />}
                nextStep={handleNext}
                prevStep={prevStep}
                loading={loading}
                nextLabel={!isSign ? 'Suivant' : !isApply ? 'Valider' : 'Continuer'}
            >

                <div className="space-y-6">
                    {!isSign ? (
                        <div className="space-y-6">
                            <p className={`${common.body} font-semibold ${classes.text}`}>
                                Veuillez signer votre procuration. Merci de bien vérifier l'ensemble des informations mentionnées.
                            </p>
                            <div className="bg-white rounded-lg border border-gray-300 p-6 relative">
                                {show && (
                                    <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 pointer-events-none">
                                        <div className="w-5/6 mx-auto border-t border-dashed border-gray-300">
                                            <p className={`text-gray-300 font-bold text-lg text-center cursor-default select-none ${classes.fontFamily}`}>
                                                Signer ici
                                            </p>
                                        </div>
                                    </div>
                                )}
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center gap-4">
                                        <button
                                            className={`cursor-pointer ${classes.background} ${classes.primaryBorder} border p-2 rounded-lg hover:opacity-80 transition-opacity`}
                                            title="Dessiner"
                                        >
                                            <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2424 3.03668H13.6618C13.2023 3.03668 12.798 3.31237 12.6325 3.71672C12.3201 3.51454 11.9525 3.29399 11.5482 3.05506C11.3644 2.94479 11.1622 2.83451 10.96 2.76099L11.1438 2.5772C11.6952 2.02582 11.6952 1.12524 11.1438 0.555479L11.0519 0.463583C10.5006 -0.0877958 9.59997 -0.0877958 9.03021 0.463583L7.02687 2.46692C5.39111 2.52206 3.60832 3.34913 2.90991 3.71672C2.70773 3.82699 2.50556 3.97403 2.35853 4.13944C0.943324 5.6833 0.373566 6.87795 0.336807 6.91471L0.300049 7.00661V7.0985C0.355187 7.7234 0.686014 8.1645 1.25577 8.34829L0.557359 10.5722C0.5206 10.7008 0.557359 10.8479 0.649255 10.9398C0.722772 11.0133 0.814669 11.05 0.906565 11.05C0.943324 11.05 0.980082 11.05 1.01684 11.0317L3.31425 10.3333C3.36939 10.3149 3.42453 10.2781 3.46129 10.2414L4.0678 9.63484C4.26997 9.72674 4.47215 9.7635 4.6927 9.7635H6.76956C7.52311 9.80026 8.40531 9.81864 9.25076 9.81864C10.9233 9.81864 12.4488 9.7635 12.4488 9.7635H12.6877C12.8899 10.0943 13.2391 10.3149 13.6618 10.3149H15.224C15.8489 10.3149 16.3452 9.81864 16.3452 9.19374V4.15782C16.3635 3.53292 15.8489 3.03668 15.2424 3.03668ZM1.0536 7.15364C1.20063 6.85957 1.77039 5.86709 2.89153 4.63568C2.98342 4.5254 3.11208 4.43351 3.24073 4.37837C3.77373 4.10268 4.96839 3.53292 6.1998 3.31237L1.78877 7.7234C1.20063 7.68664 1.07198 7.35581 1.0536 7.15364ZM3.02018 9.65322L1.47632 10.1311L1.95418 8.58723L7.41283 3.12858L7.43121 3.1102L9.54483 0.996582C9.82052 0.720893 10.2432 0.720893 10.5189 0.996582L10.6108 1.08848C10.8865 1.36417 10.8865 1.78689 10.6108 2.06258L5.55652 7.11688H4.63756C4.10456 7.11688 3.6267 7.39257 3.38777 7.85205C3.20398 8.20126 3.20398 8.58723 3.36939 8.95481C3.40615 9.02833 3.44291 9.10184 3.49804 9.17536L3.02018 9.65322ZM7.41283 6.7493C7.33931 6.95147 7.082 7.08012 6.71442 7.11688H6.58576L7.37607 6.32657C7.44959 6.49199 7.46797 6.63902 7.41283 6.7493ZM12.4488 9.02833C12.412 9.02833 9.01183 9.1386 6.78794 9.02833H4.6927C4.52728 9.02833 4.36187 8.97319 4.23322 8.88129C4.14132 8.80778 4.08618 8.73426 4.03104 8.64236C3.95753 8.47695 3.95753 8.32992 4.03104 8.18288C4.14132 7.98071 4.36187 7.85205 4.63756 7.85205H6.7328H6.82469L6.84307 7.83367C7.46797 7.76016 7.92745 7.46609 8.09286 7.00661C8.2399 6.62064 8.18476 6.17954 7.92745 5.7752L10.3719 3.34913C10.6476 3.42265 10.9233 3.5513 11.1806 3.69834C11.7136 4.01078 12.1547 4.28647 12.559 4.54378V9.04671L12.4488 9.02833ZM15.6284 9.19374C15.6284 9.41429 15.4446 9.57971 15.2424 9.57971H13.6618C13.4412 9.57971 13.2758 9.39591 13.2758 9.19374V4.15782C13.2758 3.93727 13.4596 3.77185 13.6618 3.77185H15.224C15.4446 3.77185 15.61 3.95565 15.61 4.15782V9.19374H15.6284Z" fill={brandConfig.colors.primary} />
                                            </svg>
                                        </button>
                                    </div>
                                    <button
                                        onClick={clear}
                                        className={`cursor-pointer text-sm font-semibold ${classes.text} ${classes.fontFamily} hover:opacity-80 transition-opacity`}
                                    >
                                        Effacer
                                    </button>
                                </div>
                                <SignaturePad
                                    onEnd={trim}
                                    velocityFilterWeight={0.2}
                                    onBegin={() => setShow(false)}
                                    maxWidth={1}
                                    minWidth={1}
                                    ref={padRef}
                                    canvasProps={{ className: "sigCanvas border-2 border-dotted z-50 w-full" }}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-6">
                            <p className={`${common.body} font-semibold ${classes.text}`}>
                                Votre signature a été enregistrée. Veuillez maintenant écrire la mention <span className="font-bold">"bon pour pouvoir"</span> ci-dessous.
                            </p>
                            {error === true && (
                                <p className={`${classes.error} font-medium animate-pulse`}>
                                    Merci de bien vouloir taper "Bon pour pouvoir" pour terminer votre signature
                                </p>
                            )}
                            {error === false ? (
                                <div className={`w-full ${classes.background} rounded-lg ${classes.primaryBorder} border p-6`}>
                                    <div className="py-8 w-full">
                                        <span className={`${classes.primaryText} border-b border-dashed font-crimson ${classes.primaryBorder} w-3/4 block mx-auto text-center pb-2 text-3xl font-bold`}>
                                            Bon pour pouvoir
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <div className={`w-full rounded-lg border p-6 ${error === true
                                    ? `${classes.errorBorder} bg-red-50 animate-pulse`
                                    : 'border-gray-300 bg-white'
                                    }`}>
                                    <div className="py-8 w-full">
                                        <input
                                            value={text}
                                            onChange={(e) => setText(e.target.value)}
                                            type="text"
                                            placeholder='Veuillez taper "bon pour pouvoir"'
                                            className={`bg-transparent block w-3/4 mx-auto text-center text-xl font-bold border-b border-gray-300 border-dashed pb-2 focus:outline-none focus:border-blue-500 ${classes.fontFamily}`}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </LayoutProcuration>

            <DialogLayout
                title={"Appliquer cette signature"}
                text={<p className={`${classes.text} ${classes.fontFamily} ${common.body}`}>
                    Êtes-vous certain de vouloir continuer ? En choisissant "oui", vous ne pourrez plus re-signer ce document.
                </p>}
                valid={"Oui"}
                cancel={"Non"}
                open={open}
                handleClose={() => setOpen(false)}
                handleSubmit={validateSign}
            />

        </>
    );
};

export default ThirdProcuration;
